document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-custom-menu-toggle]');
  const offcanvas = document.getElementById('custom-offcanvas');
  const overlay = document.querySelector('.custom-offcanvas-overlay');
  const closeTriggers = document.querySelectorAll('[data-offcanvas-close]');

  if (!toggle || !offcanvas || !overlay) return;

  const open = () => {
    offcanvas.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    offcanvas.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', e => {
    e.preventDefault();
    open();
  });

  closeTriggers.forEach(el =>
    el.addEventListener('click', close)
  );

  overlay.addEventListener('click', close);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') close();
  });
});


// swiper fix
document.querySelectorAll('.swiper').forEach(sw => {
  if (sw.swiper) sw.swiper.update();
});

// Product data image click
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-data-image').forEach(img => {
    img.addEventListener('click', function () {
      const overlay = document.createElement('div');
      overlay.className = 'image-overlay';

      const bigImg = document.createElement('img');
      bigImg.src = this.dataset.full;

      // Close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'image-close';
      closeBtn.innerHTML = '&times;'; // × symbol

      overlay.appendChild(closeBtn);
      overlay.appendChild(bigImg);
      document.body.appendChild(overlay);

      // Close on button click
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        overlay.remove();
      });

      // Close on background click
      overlay.addEventListener('click', () => overlay.remove());
    });
  });
});
